import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';

export class PopOver extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() { }

  render() {
    return (
      <Popover
        id={this.props.id}
        open={this.props.open}
        classes={{ paper: css(CommonStyles.menuItemPopoverContainer) }}
        anchorEl={this.props.anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={this.props.editClickClose}
      >
        {this.props.items.map(item => {
          return (
            <MenuItem
              onClick={() => this.props.onPopOverClick(item.key)}
              className={css(CommonStyles.menuItemContainer, CommonStyles.menuItemPopoverContent)}>
              <p className={css(CommonStyles.margin)}>{item.title}</p>
            </MenuItem>
          )
        })}
      </Popover>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/PopOver.js